import { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { getIsGalleryExpansionEnabled } from '@tabeeb/modules/appConfigState/selectors'

import { getIsTabExpanded } from '@tabeeb/modules/sessionTabs/selectors'
import { TabPanel } from '@tabeeb/enums'
import FoldersList from '../components/FoldersList'
import { getNestedFoldersForSelectedFolder } from '../selectors'

class FoldersListContainer extends Component {
  render() {
    const { foldersList, isGalleryExpanded, isGalleryExpansionEnabled } = this.props

    const props = {
      folders: foldersList,
      isExpanded: isGalleryExpansionEnabled && isGalleryExpanded,
    }

    return <FoldersList {...props} />
  }
}

FoldersListContainer.propTypes = {
  foldersList: PropTypes.array.isRequired,
  isGalleryExpanded: PropTypes.bool.isRequired,
  isGalleryExpansionEnabled: PropTypes.bool.isRequired,
}

const mapStateToProps = (state) => {
  return {
    foldersList: getNestedFoldersForSelectedFolder(state),
    isGalleryExpanded: getIsTabExpanded(state, TabPanel.Gallery),
    isGalleryExpansionEnabled: getIsGalleryExpansionEnabled(state),
  }
}

export default connect(mapStateToProps)(FoldersListContainer)
